import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import MarketingBanner from './MarketingBanner';
import CommitmentSection from "../CommitmentSection";
import MarketingInfo from './MarketingInfo';

const MarketingEventsDetails = () => {
  return (
    <>
      <NavbarComponent />
     <MarketingBanner/>
     <CommitmentSection/>
     <MarketingInfo/>
      <Footer />
    </>
  );
};

export default MarketingEventsDetails;
